import React from "react"

export const NewsletterSection = props => {
  return (
    <div className="newsletter-section">
      <h3 className="mb-3">Aktuelle Themen direkt ins Postfach!</h3>
      <a href="https://www.qmarketing.de/qinsights" className="q-btn q-btn-primary d-inline-flex" target="_blank">
        Newsletter abonnieren
      </a>
    </div>
  )
}

export default NewsletterSection
